module.exports = __webpack_public_path__ + "favicon/favicon_48.0049c8b6.png";